export default __webpack_public_path__ + "media/images/62-deecad34554b3d6798841f3155593bf4.jpg";